export type Language = "en" | "ja";

export const translations = {
  en: {
    appName: "irigon weather",
    poweredBy: "Powered by Open-Meteo",
    worldWeather: "World Weather",
    realtime: "Real-time weather for 3 cities",
    updated: "Updated",
    day: "Day",
    night: "Night",
    feelsLike: "Feels like",
    humidity: "Humidity",
    wind: "Wind",
    uvIndex: "UV Index",
    precipitation: "Rain",
    forecast: "7-Day Forecast",
    loading: "Loading weather data...",
    error: "Unable to load weather data.",
    retry: "Please try refreshing the page.",
    today: "Today",
    tomorrow: "Tomorrow",
    localTime: "Local Time",
    celsius: "°C",
    fahrenheit: "°F",
  },
  ja: {
    appName: "irigon weather",
    poweredBy: "Open-Meteo 提供",
    worldWeather: "世界の天気",
    realtime: "3都市のリアルタイム天気",
    updated: "更新",
    day: "昼",
    night: "夜",
    feelsLike: "体感",
    humidity: "湿度",
    wind: "風速",
    uvIndex: "UV指数",
    precipitation: "降水確率",
    forecast: "7日間予報",
    loading: "天気データを読み込み中...",
    error: "天気データを読み込めませんでした。",
    retry: "ページを更新してください。",
    today: "今日",
    tomorrow: "明日",
    localTime: "現地時刻",
    celsius: "°C",
    fahrenheit: "°F",
  },
} as const;

export type TranslationKey = keyof typeof translations.en;

export function t(lang: Language, key: TranslationKey): string {
  return translations[lang][key];
}
